import React, { useEffect, useRef, useState } from 'react';
import PhotoMode from './photo-mode';
import { PhotoScreen } from './photo-screen';
import { useMindarError } from './use-mindar-error';
import { CameraAccessMessage } from './camera-access-message';

const MindARVideo = ({ data }) => {
  const sceneRef = useRef(null);
  const sceneWrapperRef = useRef(null);

  const [procent, setProcent] = useState(1);
  const [showVideo, setShowVideo] = useState(false);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [lastPhotoUrl, setLastPhotoUrl] = useState(null);

  const hasMindArError = useMindarError(sceneRef?.current);

  async function getMediaURLForTrack(texture_to_update, passed_url) {
    await fetch(passed_url, { method: 'GET' }).then((response) => {
      texture_to_update.src = response.url;
    });
  }

  useEffect(() => {
    const sceneEl = sceneRef.current;
    const arSystem = sceneEl.systems['mindar-image-system'];

    var video = document.getElementById('myvideo');
    video.addEventListener(
      'loadedmetadata',
      function () {
        var width = this.videoWidth,
          height = this.videoHeight;
        console.log('width', width);
        console.log('height', height);
        setProcent(height / width);
      },
      false
    );
    video.crossOrigin = 'anonimous';

    getMediaURLForTrack(video, data?.filePath);

    const examplePlane = document.querySelector('#example-plane');

    examplePlane.addEventListener('click', () => {
      console.log('show video ');
      if (!showVideo) {
        setShowVideo(true);
        video.play();
      } else {
        if (data?.actionUrl !== null) {
          window.open(data?.actionUrl, '_blank');
        }
      }
    });

    return () => {
      arSystem.stop();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    var video = document.getElementById('myvideo');
    const handleTargetFound = () => {
      if (showVideo) {
        video.play();
      }
    };

    const handleTargetLost = () => {
      if (showVideo) {
        video.pause();
      }
    };
    const exampleTarget = document.querySelector('#example-target');
    if (exampleTarget != null) {
      exampleTarget.addEventListener('targetFound', handleTargetFound);
      exampleTarget.addEventListener('targetLost', handleTargetLost);
    }

    return () => {
      if (exampleTarget != null) {
        exampleTarget.removeEventListener('targetFound', handleTargetFound);
        exampleTarget.removeEventListener('targetLost', handleTargetLost);
      }
    };
  }, [showVideo, photoUrl]);

  useEffect(() => {
    var video = document.getElementById('myvideo');
    if (photoUrl === null && showVideo && lastPhotoUrl != null) {
      getMediaURLForTrack(video, data?.filePath).then(() => {
        video.play();
      });
    }
    setLastPhotoUrl(photoUrl);
  }, [data?.filePath, lastPhotoUrl, photoUrl, showVideo]);

  function take_photo() {
    const myVideo = document.getElementById('myvideo');
    myVideo.pause();
    const video =
      sceneWrapperRef.current.children[
        sceneWrapperRef.current.children.length - 1
      ];
    const canvas = document.createElement('canvas');
    video.pause();

    const style = window.getComputedStyle(video),
      width = parseFloat(style.getPropertyValue('width')),
      height = parseFloat(style.getPropertyValue('height')),
      top = parseFloat(style.getPropertyValue('top')),
      left = parseFloat(style.getPropertyValue('left'));

    const imgLeft = (left * video.videoWidth) / width;
    const imgTop = (top * video.videoHeight) / height;
    const drawLeft = imgLeft > 0 ? 0 : imgLeft;
    const drawTop = imgTop > 0 ? 0 : imgTop;
    const drawWidth = video.videoWidth;
    const drawHeight = video.videoHeight;
    canvas.width = video.videoWidth + imgLeft * 2;
    canvas.height = video.videoHeight + imgTop * 2;

    const imgDataElement = document
      .querySelector('a-scene')
      .components.screenshot.getCanvas('perspective');
    const ctx = canvas.getContext('2d');

    ctx.drawImage(video, drawLeft, drawTop, drawWidth, drawHeight);
    ctx.drawImage(imgDataElement, 0, 0, canvas.width, canvas.height);

    const url = canvas.toDataURL('image/png');
    setPhotoUrl(url);
  }

  if (photoUrl !== null) {
    return <PhotoScreen url={photoUrl} setUrl={setPhotoUrl} />;
  }

  return (
    <>
      {hasMindArError && <CameraAccessMessage />}
      <div
        id="arScene"
        ref={sceneWrapperRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <a-scene
          ref={sceneRef}
          mindar-image={`imageTargetSrc:${data?.trigger?.filePath};uiScanning: no;filterMinCF:0.0001; filterBeta: 0.001;`}
          color-space="sRGB"
          embedded
          renderer="colorManagement: true"
          vr-mode-ui="enabled: false"
          device-orientation-permission-ui="enabled: false"
          height="100%"
          width="100%"
        >
          <a-assets>
            <img
              alt=""
              id="myimage"
              src={`https://storage.yandexcloud.net/zrenie-dev-bucket/%D0%A2%D0%B5%D1%81%D1%82%D1%8B%20%D0%B4%D0%BB%D1%8F%20%D0%B4%D0%B5%D0%BC%D0%BE/play-button.png`}
            />
            <video
              id="myvideo"
              // src={`${data?.filePath}`}
              type="video/mp4"
              loop={true}
              scale={1}
              playsInline
              crossOrigin="anonymous"
              controls
            ></video>
          </a-assets>

          <a-camera
            fov="80"
            position="0 0 0"
            look-controls="enabled: false"
            height="100%"
            width="100%"
            id="user-camera"
            className="user-camera"
            cursor="fuse: false; rayOrigin: mouse;"
            raycaster="near: 10; far: 10000; objects: .clickable"
          ></a-camera>

          <a-entity id="example-target" mindar-image-target="targetIndex: 0">
            <a-plane
              id="example-plane"
              class="clickable"
              src={`${showVideo ? '#myvideo' : '#myimage'}`}
              position={
                showVideo
                  ? `${data?.offsetX !== null ? data?.offsetX : 0} ${
                      data?.offsetY !== null ? data?.offsetY : 0
                    } ${data?.offsetZ !== null ? data?.offsetZ : 0}`
                  : '0 0 0'
              }
              scale={
                showVideo
                  ? `${data?.scale !== null ? data.scale : 1} ${
                      procent * (data?.scale !== null ? data.scale : 1)
                    } 1`
                  : '1 1 1'
              }
              rotation="0 0 0"
              transparent="true"
            ></a-plane>
          </a-entity>
        </a-scene>
        <PhotoMode take_photo={take_photo} />
      </div>
    </>
  );
};

export default MindARVideo;
